import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './StickyBookNow.css';

const StickyBookNow = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // ⛔ Hide button on /bookappointment page
  if (location.pathname === '/bookappointment') {
    return null;
  }

  const handleClick = () => {
    if (location.pathname !== '/') {
      navigate('/bookappointment');
      setTimeout(() => {
        const section = document.getElementById('appointment');
        if (section) section.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    } else {
      const section = document.getElementById('appointment');
      if (section) section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <button className="sticky-book-btn" onClick={handleClick}>
      📅 Book Now
    </button>
  );
};

export default StickyBookNow;